import { render, staticRenderFns } from "./SubscriptionsHistoryTable.vue?vue&type=template&id=1a8d1c26&scoped=true&"
import script from "./SubscriptionsHistoryTable.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionsHistoryTable.vue?vue&type=style&index=0&id=1a8d1c26&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8d1c26",
  null
  
)

export default component.exports